import { ArrowUpRight } from "lucide-react";
import { waLink, GENERAL_MESSAGE, WHATSAPP_DISPLAY } from "@/lib/store";
import { WhatsAppIcon } from "./WhatsAppIcon";
import { Reveal, Eyebrow } from "./Reveal";
import { StoreStatus } from "./StoreStatus";

export const Contact = () => (
  <section id="contato" data-testid="contact-section" className="relative overflow-hidden border-t border-white/10">
    <div className="absolute inset-0 spotlight opacity-60" aria-hidden="true" />
    <div className="relative mx-auto max-w-[1440px] px-5 sm:px-8 py-24 sm:py-40">
      <Reveal>
        <Eyebrow>(03) — Contato</Eyebrow>
        <h2 className="font-display mt-6 text-[15vw] sm:text-8xl lg:text-[10rem] font-extrabold leading-[0.85] tracking-[-0.05em] text-white">
          Viu o seu?<br /><span className="text-outline">Chama.</span>
        </h2>
      </Reveal>
      <Reveal delay={0.1} className="mt-14 flex flex-col gap-8 md:flex-row md:items-end md:justify-between">
        <a data-testid="contact-whatsapp-button" href={waLink(GENERAL_MESSAGE)} target="_blank" rel="noopener noreferrer"
          className="group inline-flex w-full sm:w-auto items-center justify-between gap-6 rounded-full bg-[#25D366] py-3 pl-7 pr-3 text-black transition-transform duration-300 hover:scale-[1.02] active:scale-95">
          <span className="flex items-center gap-3 text-lg font-bold"><WhatsAppIcon className="h-6 w-6" /> Conversar agora</span>
          <span className="flex h-12 w-12 items-center justify-center rounded-full bg-black text-white transition-transform duration-500 group-hover:rotate-45">
            <ArrowUpRight className="h-5 w-5" />
          </span>
        </a>
        <div>
          <p className="mono text-[11px] uppercase tracking-[0.28em] text-zinc-400">WhatsApp</p>
          <p data-testid="contact-phone" className="font-display mt-2 text-3xl sm:text-4xl font-bold text-white">{WHATSAPP_DISPLAY}</p>
          <StoreStatus testid="contact-store-status" className="mt-3" />
        </div>
      </Reveal>
    </div>
  </section>
);
